import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import OverlayComponent from "../components/AwardsAndAffiliationsOverlay.jsx";

const SELECTORS = {
  itemsWrapper: "[data-awards-and-affiliations-items]",
  item: "[data-awards-and-affiliations-item]",
  trigger: "[data-awards-and-affiliations-trigger]",
  body: "[data-awards-and-affiliations-body]",
  type: ".b-awards-and-affiliations__item-header span",
  logo: ".b-awards-and-affiliations__item-logo",
  title: ".b-awards-and-affiliations__item-title",
};

export default class AwardsAndAffiliations extends BaseModule {
  init() {
    this.items = this.collectItems();

    if (!this.items.length) {
      return;
    }

    this.mountTarget = document.createElement("div");
    this.mountTarget.className = "b-awards-and-affiliations__overlay-root";
    this.el.appendChild(this.mountTarget);

    this.isOpen = false;
    this.activeItem = null;

    this.handleClose = this.handleClose.bind(this);
    this.attachTriggerListeners();

    this.render();
  }

  collectItems() {
    const nodes = Array.from(this.el.querySelectorAll(SELECTORS.item));

    return nodes
      .map((node, index) => {
        const trigger = node.querySelector(SELECTORS.trigger);
        const typeEl = node.querySelector(SELECTORS.type);
        const logoEl = node.querySelector(SELECTORS.logo);
        const titleEl = node.querySelector(SELECTORS.title);
        const bodyEl = node.querySelector(SELECTORS.body);

        if (!trigger) {
          return null;
        }

        return {
          id: node.id || `awards-item-${index}`,
          trigger,
          type: typeEl ? typeEl.textContent.trim() : "",
          logoHTML: logoEl ? logoEl.innerHTML.trim() : "",
          title: titleEl ? titleEl.textContent.trim() : "",
          body: bodyEl ? bodyEl.innerHTML.trim() : "",
        };
      })
      .filter(Boolean);
  }

  attachTriggerListeners() {
    this.items.forEach((item) => {
      if (!item.trigger) {
        return;
      }

      const handler = (event) => this.handleTriggerClick(event, item);
      item.trigger.addEventListener("click", handler);
      item.triggerHandler = handler;
    });
  }

  detachTriggerListeners() {
    this.items.forEach((item) => {
      if (item.trigger && item.triggerHandler) {
        item.trigger.removeEventListener("click", item.triggerHandler);
        item.triggerHandler = null;
      }
    });
  }

  handleTriggerClick(event, item) {
    event.preventDefault();

    this.activeItem = item;
    this.isOpen = true;
    this.render();
  }

  handleClose() {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.activeItem = null;
    this.render();
  }

  render() {
    if (!this.mountTarget) {
      return;
    }

    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.mountTarget);
    }

    this.reactRoot.render(
      createElement(OverlayComponent, {
        isOpen: this.isOpen,
        item: this.activeItem,
        onClose: this.handleClose,
      })
    );
  }

  destroy() {
    this.detachTriggerListeners();

    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }

    if (this.mountTarget) {
      this.mountTarget.remove();
      this.mountTarget = null;
    }

    this.items = [];
    this.activeItem = null;
    this.isOpen = false;
  }
}
